<div class="container mt-4">
  <div class="card shadow-sm">
    <div class="table-responsive p-3">

      <!-- Header & ADD Button -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h4 class="mb-0">Microsoft Dynamic 360 checker Access</h4>
        
      </div>

      <!-- Employee Table -->
       <div class="table-responsive modern-table-container">
  <table class="table table-bordered table-hover">
        <thead class="table-dark">
          <tr>
            <th>#</th>
            <th>Action</th>
            <th>Emp Code</th>
            <th>Full Name</th>
            <th>Designation</th>
            <th>Location</th>
            <th>Department</th>
            <th>Micrsoft Dynamic 360</th>
            <th>Company Name</th>
            <th>User Id</th>
            <th>Role Center</th>
            <th>Previlage Access</th>
            <th>Approval Access</th>
            
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let emp of appservice.Microsoft_360CheckerRejectgrid; let i = index">
            <!-- Index -->
            <td>{{ i + 1 }}</td>

            <!-- Action Dropdown -->
            <td class="text-center"><div class="Dropdown">
              <button class="icon-button me-1" ([ngModel])="appservice.Microsoft_checkRejecteditid" (click)="editEmployee(emp.MD_EmployeeId)" title="Edit">
    <img src="assets/images/edit.png" alt="Edit" width="20" height="20">
  </button>
  </div>
            </td>

            <!-- Data Columns -->
            <td>{{ emp.MD_EmployeeId }}</td>
            <td>{{ emp.MD_Fullname }}</td>
            <td>{{ emp.MD_Designation }}</td>
            <td>{{ emp.MD_Grade }}</td>
            <td>{{ emp.MD_Department }}</td>
            <td>{{ emp.MD_Micsoftdynamic360 }}</td>
            <td>{{ emp.MD_company_name }}</td>
            
            <td>{{ emp.MD_UserId }}</td>
            <td>{{ emp.MD_RoleCenter }}</td>
            <td>{{ emp.MD_Previlage_Access }}</td>
            <td>{{ emp.MD_Approval_Access }}</td>
            <td>{{ emp.MD_checker_approvedby }}</td>
          </tr>
        </tbody>
      </table>
</div>
    </div>
  </div>
</div>
